import house1 from "./media/image1.png";
import house2 from "./media/image2.png";
import house3 from "./media/image3.png";

export const properties = [
  {
    id: "1",
    img: house1,
    price: "35000",
    address: "8502 Preston Rd. Inglewood, Maine 98280",
    bedrooms: 2,
    bathrooms: 2,
    space: 2000,
  },

  {
    id: "2",
    img: house2,
    price: "38000",
    address: "Wailuku, HI 96793",
    bedrooms: 3,
    bathrooms: 2,
    space: 2300,
  },

  {
    id: "3",
    img: house3,
    price: "47000",
    address: "2917 23rd St",
    bedrooms: 4,
    bathrooms: 3,
    space: 3000,
  },
];
